import { EntityBasic } from '../../../interfaces/EntityBasic';
import { paymentService } from '../../../../shared/services/paymentService';
import { PAYMENT_FLOW_TYPE } from '../../../../shared/constants/user-info/paymentFlowType';
import { entityGeneralSetupService } from '../../../../payment';
import {
  isCoachSeatsLimitReached,
  formatSeatsLimitError,
} from '../../../../shared/utils/coachSeatsUtils/coachSeatsUtils';

export const validateCoachSeats = async (entity?: EntityBasic) => {
  if (!entity) {
    return true;
  }

  const { paymentFlowType } = await paymentService.getPaymentFlowType(entity.id);
  if (paymentFlowType !== PAYMENT_FLOW_TYPE.NEW_USER_FLOW_2024) {
    return true;
  }

  const seats = await entityGeneralSetupService.getCoachSeats(entity.id);

  return !isCoachSeatsLimitReached(seats) || formatSeatsLimitError(seats);
};
